import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ButtonGroup, Button } from "react-bootstrap";
import {
  imageExtensions,
  getFileCategoryType,
  imageExtensionsBrowserNative,
} from "../../util/file";
import ViewerWrapper from "./ViewerWrapper";

function ImageViewer({ filename }) {
  const [content, setContent] = useState("");
  const [zoomLevel, setZoomLevel] = useState(100);
  const [lastClicked, setLastClicked] = useState(null);
  const [fetchURL, setFetchURL] = useState("");
  let location = useLocation();

  useEffect(() => {
    const filePath = location.pathname.replace(/\/$/, "");
    const fileCategory = getFileCategoryType(filePath.split("/")[1]);

    const BASE_URL = window.location.origin;
    const FILE_URL = `${BASE_URL}${filePath}.${
      filePath.split("/")[1]
    }.${fileCategory}.png`;

    const CONTENT_URL = imageExtensions.reduce(
      (url, ext) => url.replace(`${ext}/`, ""),
      FILE_URL
    );
    setContent(CONTENT_URL);

    const FETCH_URL = imageExtensions.reduce(
      (url, ext) => url.replace(`${ext}/`, ""),
      `${BASE_URL}${filePath}.${filePath.split("/")[1]}`
    );
    setFetchURL(FETCH_URL);

    if (imageExtensionsBrowserNative.includes(filePath.split("/")[1])) {
      setContent(FETCH_URL);
    }
  }, [filename, location.pathname]);

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 25, 400));
    setLastClicked("in");
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 25, 25));
    setLastClicked("out");
  };

  return (
    <ViewerWrapper isImageViewer fileUrl={fetchURL}>
      <div className="image-container">
        {content && (
          <img
            src={content}
            alt={filename}
            style={{ transform: `scale(${zoomLevel / 100})` }}
          />
        )}
      </div>

      <ButtonGroup className="zoom-button-group" style={{ marginTop: "7px" }}>
        <Button
          variant="secondary"
          onClick={handleZoomOut}
        >
          Zoom Out
        </Button>
        <Button variant="secondary" disabled style={{ borderRadius: "0" }}>
          {zoomLevel}%
        </Button>
        <Button
          variant="secondary"
          onClick={handleZoomIn}
        >
          Zoom In
        </Button>
      </ButtonGroup>

      <style jsx>{`
        .image-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: calc(90vh - 50px); /* Subtract header height */
          // padding-bottom: 50px;
          overflow: auto;
        }
        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          transition: transform 0.2s ease;
          transform-origin: center center;
        }
      `}</style>
    </ViewerWrapper>
  );
}

export default ImageViewer;
